import { alpha, List, styled } from '@mui/material';

import { SOURCING_PROJECT_SUPPLIER_LIST_ITEM_HEIGHT } from '../SupplierListItem/SupplierListItem';

export const StyledList = styled(List, {
  // Prevents 'hasMore' prop from being forwarded to the DOM element
  shouldForwardProp: (prop) => prop !== 'hasMore' && prop !== 'length',
})<{ hasMore?: boolean; length?: number }>(({ theme, hasMore, length = 0 }) => ({
  overflow: 'hidden',
  maxHeight: length * SOURCING_PROJECT_SUPPLIER_LIST_ITEM_HEIGHT,
  ':after': hasMore
    ? {
        content: '""',
        display: 'block',
        position: 'absolute',
        bottom: 0,
        width: '100%',
        height: '100px',
        pointerEvents: 'none',
        background: `linear-gradient(0deg, ${alpha(theme.palette.background.default, 1)} 20%, ${alpha(theme.palette.background.default, 0)} 100%)`,
      }
    : undefined,
}));
